interface ConditionalWrapperProps {
  shouldWrap: boolean;
  className?: string;
  children: React.ReactNode;
}

export const ConditionalWrapper = (props: ConditionalWrapperProps) => {
  const { shouldWrap, className, children } = props;

  return shouldWrap ? (
    <div className={className}>{children}</div>
  ) : (
    <>{children}</>
  );
};
